import { render } from "./Editor.vue?vue&type=template&id=6ed59794"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=6ed59794&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/wpcm/fields/Editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ed59794"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ed59794', __exports__)) {
    api.reload('6ed59794', __exports__)
  }
  
  module.hot.accept("./Editor.vue?vue&type=template&id=6ed59794", () => {
    api.rerender('6ed59794', render)
  })

}


export default __exports__